/* eslint-disable no-underscore-dangle */
import { getDefaultTheme, BreakPoint } from '@elliemae/pui-theme';
import { Logger } from '@elliemae/pui-diagnostics';
import { IMicroFEGuest } from './guest.js';
import { IMicroFEHost } from './host.js';

export type EMUI = {
  [key: string]:
    | Omit<IMicroFEGuest, 'guestWindow'>
    | Omit<IMicroFEGuest, 'guestWindow'>[];
} & {
  _BASE_PATH: string;
  _ASSET_PATH: string;
  version: string;
  __host?: IMicroFEHost;
  getHost?: () => IMicroFEHost | null;
  logger?: Logger;
  appId?: string;
  registerApp?: (options: { appId: string; app: IMicroFEGuest }) => void;
  unregisterApp?: (instanceId: string) => void;
};

declare global {
  interface Window {
    emui: EMUI;
    __ICE__?: EMUI;
  }
}

export const getWindow = () => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    window.parent.document;
    return window.parent;
  } catch (err) {
    return window;
  }
};

export const getViewportSize = () => ({
  width: Math.max(
    document.documentElement.clientWidth || 0,
    window.innerWidth || 0,
  ),
  height: Math.max(
    document.documentElement.clientHeight || 0,
    window.innerHeight || 0,
  ),
});

const convertBreakpointToNumber = (breakpoint: string) =>
  Number(breakpoint.replace('px', ''));

export const getCurrentBreakpoint = (): BreakPoint => {
  const { width } = getViewportSize();
  const { breakpoints } = getDefaultTheme();
  if (width <= convertBreakpointToNumber(breakpoints.small)) return 'small';
  if (width <= convertBreakpointToNumber(breakpoints.medium)) return 'medium';
  return 'large';
};
